import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';

import * as NotificationsConfig from 'notifications_config/components';

class NotificationsConfigRowContainer extends Component {
  render = () => (
    <NotificationsConfig.Row
      handleToggle={this.props.handleToggle}
      notificationConfig={this.props.notificationConfig}
      company={this.props.company}
      subcompany={this.props.subcompany}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(NotificationsConfigRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/containers/NotificationConfigRowContainer.js